/**
 * Azure session storage constants and names
 */
export const SESSION =
  {
    AUTH_ID: "BBT_AUTH_ID",
  };